import React, { useState, useEffect, useContext } from "react";
import EditorSlot from "./EditorSlot";
import Frame from "./Frame";
import PageTitle from "./PageTitle";
import { editorById, listEditors } from "../helper/api-editors";
import { GlobalContext } from "../context/GlobalContext";

export default function EditorialBoard() {
  const { settings } = useContext(GlobalContext);
  const [chiefEditors, setChiefEditors] = useState([]);
  const [associateEditors, setAssociateEditors] = useState([]);
  const [assistantEditors, setAssistantEditors] = useState([]);
  const [rankAssociate, setRankAssociate] = useState([]);
  const [hide, setHide] = useState(false); // Initialize hide state

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    listEditors(signal).then((data) => {
      if (data && data.error) {
        console.error(data.error);
      } else if (data) {
        setRankAssociate(
          data
            .filter((editor) => editor.postion !== 0)
            .sort((a, b) => {
              return a.postion - b.postion;
            })
        );
        // setAssistantEditors(
        //   data.filter(
        //     (editor) =>
        //       editor.status === "enabled" &&
        //       editor.category === "assistant editor"
        //   )
        // );
        setAssociateEditors(
          data.filter(
            (editor) =>
              editor.status === "enabled" &&
              editor.category === "associate editor" &&
              editor.postion === 0
          )
        );
        setChiefEditors(
          data.filter(
            (editor) =>
              editor.status === "enabled" && editor.category === "chief editor"
          )
        );
      }
    });

    return function cleanup() {
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    // Define domains where you want to hide email and phone numbers
    const domainsToHide = [
      "www.botanyjournals.com",
      "www.entomologyjournals.com",
      "www.fishjournals.com",
      "www.foodsciencejournal.com",
      "www.chemicaljournals.com",
      "www.chemistryjournal.in",
      "www.pharmacyjournal.net",
      "www.pharmacyjournal.in",
      "www.biologyjournal.in",
    ];

    // Check if current domain is in domainsToHide
    const shouldHide = domainsToHide.includes(settings.domain);
    setHide(shouldHide); // Update hide state based on domain check
  }, [settings]);
  useEffect(() => {
    const journals = [
      "www.botanyjournals.com",
      "www.entomologyjournals.com",
      "www.fishjournals.com",
      "www.foodsciencejournal.com",
      "www.chemicaljournals.com",
      "www.chemistryjournal.in",
      "www.pharmacyjournal.net",
      "www.pharmacyjournal.in",
      "www.biologyjournal.in",
    ];

    journals.includes(settings.domain) ? setHide(false) : setHide(true);
  }, [settings]);

  return (
    <div className="page">
      <PageTitle title="EDITORIAL BOARD" />

      {chiefEditors.length > 0 && (
        <Frame title="Editor-in-Chief">
          {chiefEditors.map((editor, index) => {
            return (
              <EditorSlot
                key={`chiefeditor-${index + 1}`}
                editor={editor}
                hide={hide}
              />
            );
          })}
          {/* {chiefEditors.map((editor, index) => (
            <EditorSlot
              key={`chiefeditor-${index + 1}`}
              editor={editor}
              hide={hide}
            />
          ))} */}
        </Frame>
      )}

      {/* {associateEditors.length > 0 && (
        <Frame title="Associate Editors">
          {associateEditors.map((editor, index) => {
            return (
              <EditorSlot
                key={`associateEditor-${index + 1}`}
                editor={editor}
                hide={hide}
              />
            );
          })}
          {associateEditors.map((editor, index) => (
            <EditorSlot key={`associateEditor-${index + 1}`} editor={editor} hide={hide} />
          ))}
        </Frame>
      )} */}

      {(associateEditors.length > 0 || rankAssociate.length > 0) && (
        <Frame title="Associate Editors">
          {rankAssociate.length > 0 &&
            rankAssociate.map((editor, index) => {
              return (
                <EditorSlot
                  key={`associateEditor-${index + 1}`}
                  editor={editor}
                  hide={hide}
                />
              );
            })}
          {associateEditors.length > 0 &&
            associateEditors.map((editor, index) => {
              return (
                <EditorSlot
                  key={`associateEditor-${index + 1}`}
                  editor={editor}
                  hide={hide}
                />
              );
            })}
        </Frame>
      )}
      {/* 
      {(assistantEditors.length > 0 || rankAssistant.length > 0) && (
        <Frame title="Assistant Editors">
          {rankAssistant.length > 0 &&
            rankAssistant.map((editor, index) => {
              return (
                <EditorSlot
                  key={`assistantEditor-${index + 1}`}
                  editor={editor}
                  hide={hide}
                />
              );
            })}
          {assistantEditors.length > 0 &&
            assistantEditors.map((editor, index) => {
              return (
                <EditorSlot
                  key={`assistantEditor-${index + 1}`}
                  editor={editor}
                  hide={hide}
                />
              );
            })}
        </Frame>
      )} */}
    </div>
  );
}
